var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"tips-tooltip regular",style:(_vm.tooltipStyle),on:{"click":function($event){$event.stopPropagation();return _vm.hideTooltip.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }